import kea = require('node_modules/kea-react/dist/index');
import models = require("app/models/requireme");
import { rpcController } from "../rpc";
import { cacheResource, bindResource, rpcCrudService } from "kea-resource";
import { CampoRepetidoIdentificacion, ResourceIdentificacionRepetido } from "./identificacion";

const controller = rpcController("FacturacionGuia");
const crud = rpcCrudService<models.Factura, models.FacturaDto>(controller);

const otros = {
    /**
     * * Genera una factura a partir de un conjunto de guías
     * * @param foliosGuias 
     * */
    FacturarGuias: async (folios: string[]): Promise<number> => await controller("FacturarGuias", { folios }),

    /**
 * * Genera una factura a partir de un conjunto de guías sin timbrar la factura
 * * @param foliosGuias 
 * */
    FacturarGuiasSinTimbrar: async (folios: string[]): Promise<number> => await controller("FacturarGuiasSinTimbrar", { folios }),
    FacturarGuiasPublicoGeneral: async (folios: string[]): Promise<number> => await controller("FacturarGuiasPublicoGeneral", { folios }),
    FacturarGuiasOnline: async (facturacionOnline: models.FacturacionOnline): Promise<number> => await controller("FacturarGuiasOnline", {}, facturacionOnline),


    /**
     * Genera una factura en base a todas las guías que están disponibles para facturar y las timbra
    * @param folios 
    */
    FacturarGuiasPublico: async (): Promise<void> => await controller("FacturarGuiasPublico", {}),

    /**
  * Genera una factura en base a todas las guías que están disponibles para facturar
 * @param folios 
 */
    FacturarGuiasPublicoSinTimbrar: async (): Promise<void> => await controller("FacturarGuiasPublicoSinTimbrar", {}),

    /**
     * Regresa la cantidad de guías que se pueden facturar
     */
    CantidadGuiasAFacturar: async (): Promise<number> => await controller("CantidadGuiasAFacturar", {}),


    /** Genera una factura en base a todas las guías de EAD pagadas de FXC de contado que están disponibles para facturar y las timbra*/
    FacturarGuiasEADContadoFXC: async (): Promise<void> => await controller("FacturarGuiasEADContadoFXC", {}),


    /** Genera una factura en base a todas las guías de EAD pagadas de FXC de contado que están disponibles para facturar*/
    FacturarGuiasEADContadoFXCSinTimbrar: async (): Promise<void> => await controller("FacturarGuiasEADContadoFXCSinTimbrar", {}),

}

export const FacturacionGuia = cacheResource({
    ...otros
}, {
    }, {
        FacturarGuias: true,
        FacturarGuiasOnline: true,
        FacturarGuiasPublicoGeneral: true
    })


// WEBPACK FOOTER //
// ./app/resources/items/facturacionguia.ts